import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetCaseDocTypes = ({ matterId, subsetId }: { matterId: string; subsetId: string }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<string[]>(
    [QueryEntity.DocTypes, { matterId, subsetId }],
    async () => {
      return fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/doc-types`, fetchConfigGET).then(
        (res) => res.json(),
      );
    },
    { enabled: Boolean(matterId) && Boolean(subsetId), staleTime: Infinity, refetchOnWindowFocus: false },
  );
};
